<template>
    <div>
        <input
            @change="changeFile"
            ref="file"
            type="file"
            multiple=false
            accept="image/*"
        />
        <input
                @change="changeFile2"
                ref="file2"
                type="file"
                multiple=false
        />
    </div>
</template>

<script>
    import {fileToNase64} from "../../lib/hos/until"
    import {disService} from "../../lib/service/dis"
    import loadAjax from "../../lib/service/loadAjax"
    export default {
        name: "dis-msg-load",
        data(){
            return {
                id:"",
                accept:"image/*"//图片类型 image/* 文件类型 'application/pdf', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/zip', 'rar'
            }
        },
        methods:{
            start(id){
                this.id = id;
                this.$refs['file'].click();
            },
            startFile(id){
                this.id = id;
                this.$refs['file2'].click();
            },
            async changeFile2(){
                let fileInput = this.$refs.file2;
                let files = fileInput.files[0];
                if(['application/pdf', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/zip', 'rar'].indexOf(files.type) == -1){
                    this.$message.error('文件格式不支持');
                    return
                }
                if(files.size / 1024 /1024 /1024> 50){
                    this.$message.error('图片大小超过50MB');
                    return
                }

                const {code,obj} = await loadAjax(files,{
                    "module":"BASE",
                    "fileType":"TEXT",
                    "fileName":files.name
                });
                if(code == 0){
                    if(await disService.reply({
                        outpatientId:this.id,
                        msgType:'FILE',
                        msgContent:obj.id
                    })){
                        this.$emit('succ');
                    }
                }
            },
            async changeFile(){
                let fileInput = this.$refs.file;
                let files = fileInput.files;
                if(files[0].size / 1024 /1024 /1024> 5){
                    this.$message.error('图片大小超过5MB');
                    return;
                }
                const fileBase = await fileToNase64(files[0]);//文件转base64
                const {code,obj} = await disService.loadBase({
                    module:"SNS",
                    fileType:"IMAGE",
                    fileName:files[0].name,
                    base64:fileBase
                });
                if(code == 0){
                    if(await disService.reply({
                        outpatientId:this.id,
                        msgType:'PIC',
                        msgContent:obj.id
                    })){
                        this.$emit('succ');
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>